<template>
  <div>
    <div class="page-wrapper only-body">
      <div class="page-header">
        <Header />
      </div>
      <div class="page-body-wrapper">
        <div class="page-body">
          <transition name="fadeIn" enter-active-class="animated fadeIn">
            <div class="container-fluid p-0">
              <div class="d-flex flex-wrap gap-4">
                <div class="row small-card m-0">
                  <div class="col-auto image" style="background-color: #009a78">
                    <img src="../assets/images/product/URBANLUME.png" />
                  </div>
                  <div class="col desc">
                    <h3>URBANLUME</h3>
                    <p class="text-green">Complete Smart Lighting System</p>
                    <p class="mt-3">
                      URBANLUME is a complete smart lighting system engineered
                      to help users to monitor and control the entire lighting
                      operations from street lights to façade lighting.
                    </p>
                    <p class="text-green">
                      <span class="text-black">Solution Status : </span
                      >Subscribed
                    </p>
                    <div class="d-flex">
                      <button
                        class="btn mt-4"
                        @click="
                          download([
                            'Urbanlume%20Facade%20Lighting%20Brochure.pdf',
                            'Urbanlume%20Smart%20Steet%20Light%20Brochure.pdf',
                          ])
                        "
                      >
                        <img src="../assets/images/icon/download.png" />
                        Download Brochure
                      </button>
                      <button class="btn bg-blue mt-4" @click="goTo">
                        See Assets <i class="fa fa-angle-right pull-right"></i>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="row small-card m-0">
                  <div class="col-auto image" style="background-color: #009a78">
                    <img src="../assets/images/product/VECTOFAMS.png" />
                  </div>
                  <div class="col desc">
                    <h3>SAN-i SENSE</h3>
                    <p class="text-green">Smart Toilet System</p>
                    <p class="mt-3">
                      SAN-i SENSE is a smart toilet system designed to help
                      facility managers to monitor facility cleanliness and
                      performance with the aid of our 'Auto-clean' and smart
                      feedback panel.
                    </p>
                    <p class="text-yellow">
                      <span class="text-black">Solution Status : </span>Not
                      Subscribed
                    </p>
                    <div class="d-flex">
                      <a class="d-contents" href="mailto:sales@vectolabs.com">
                        <button class="btn bg-yellow mt-4">
                          <img src="../assets/images/icon/email.png" />
                          Contact Us
                        </button></a
                      >
                      <button class="btn mt-4" @click="preview('vectofams')">
                        <img src="../assets/images/icon/preview.png" />
                        Preview
                      </button>
                      <button
                        class="btn mt-4"
                        @click="
                          download([
                            'Vectofams%20Smart%20Toilet%20Brochure.pdf',
                          ])
                        "
                      >
                        <img src="../assets/images/icon/download.png" />
                        Download Brochure
                      </button>
                    </div>
                  </div>
                </div>
                <div class="row small-card m-0">
                  <div class="col-auto image" style="background-color: #009a78">
                    <img src="../assets/images/product/ENERTRACE.png" />
                  </div>
                  <div class="col desc">
                    <h3>ENERTRACE</h3>
                    <p class="text-green">Smart Energy Monitoring</p>
                    <p class="mt-3">
                      ENERTRACE is a smart energy monitoring system developed to
                      help users such as building managers and energy auditors
                      to monitor power consumption, energy cost, power
                      effectiveness and more!
                    </p>
                    <p class="text-yellow">
                      <span class="text-black">Solution Status : </span>Not
                      Subscribed
                    </p>
                    <div class="d-flex">
                      <a class="d-contents" href="mailto:sales@vectolabs.com">
                        <button class="btn bg-yellow mt-4">
                          <img src="../assets/images/icon/email.png" />
                          Contact Us
                        </button></a
                      >
                      <button class="btn mt-4" @click="preview('enertrace')">
                        <img src="../assets/images/icon/preview.png" />
                        Preview
                      </button>
                      <button
                        class="btn mt-4"
                        @click="
                          download([
                            'Enertrace%20Energy%20Monitoring%20Brochure.pdf',
                          ])
                        "
                      >
                        <img src="../assets/images/icon/download.png" />
                        Download Brochure
                      </button>
                    </div>
                  </div>
                </div>
                <div class="row small-card m-0">
                  <div class="col-auto image" style="background-color: #009a78">
                    <img src="../assets/images/product/PEDES.png" />
                  </div>
                  <div class="col desc">
                    <h3>AI-LINTAS</h3>
                    <p class="text-green">Smart Traffic System</p>
                    <p class="mt-3">
                      AI-LINTAS is a complete smart traffic system engineered to
                      help users to monitor and control the entire traffic
                      operations. Equipped with radar technology for accurate
                      traffic detection.
                    </p>
                    <p class="text-yellow">
                      <span class="text-black">Solution Status : </span>Not
                      Subscribed
                    </p>
                    <div class="d-flex">
                      <a class="d-contents" href="mailto:sales@vectolabs.com">
                        <button class="btn bg-yellow mt-4">
                          <img src="../assets/images/icon/email.png" />
                          Contact Us
                        </button></a
                      >
                      <button class="btn mt-4" @click="preview('pedes')">
                        <img src="../assets/images/icon/preview.png" />
                        Preview
                      </button>
                      <button
                        class="btn mt-4"
                        @click="
                          download(['Pedes%20Smart%20Traffic%20Brochure.pdf'])
                        "
                      >
                        <img src="../assets/images/icon/download.png" />
                        Download Brochure
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </transition>
        </div>
      </div>
    </div>
    <vue-easy-lightbox
      :visible="visible"
      :imgs="lightBoxImages"
      @hide="handleHide"
    >
    </vue-easy-lightbox>
  </div>
</template>

<script>
import Header from "../components/header";
import HomeMap from "./maps/maps/homeMap.vue";
import { S3_URL } from "../constants/index";
import { getCookies, setCookies } from "@/utils";

export default {
  name: "homepage",
  components: {
    Header,
    HomeMap,
  },
  data() {
    return {
      lightBoxImages: [],
      visible: false,
    };
  },
  created() {
    this.setHeaderComponent();
  },
  mounted() {
    const version = getCookies("version");
    const queryVersion = this.$router?.query?.version || null;
    const redirect = !!getCookies("redirect");
    if ((queryVersion === "2" || version === "2") && !redirect) {
      setCookies("version", "2");
      this.$router.push("/home");
      return;
    } else if ((queryVersion === "2" || version === "2") && redirect) {
      window.location.href = `https://ppj.vectolabs.com/`;
      return;
    }
  },
  methods: {
    goTo() {
      this.$router.push("/home");
    },
    download(url) {
      url.forEach((link) => {
        window.open(S3_URL + link);
      });
    },
    handleHide() {
      this.visible = false;
    },
    preview(key) {
      this.visible = true;
      switch (key) {
        case "enertrace":
          this.lightBoxImages = [
            require("@/assets/images/preview/enertrace.png"),
          ];
          break;
        case "vectofams":
          this.lightBoxImages = [
            require("@/assets/images/preview/vectofams-1.png"),
            ,
            require("@/assets/images/preview/vectofams-2.png"),
          ];
          break;
        case "pedes":
          this.lightBoxImages = [require("@/assets/images/preview/pedes.png")];
          break;

        default:
          break;
      }
    },
    setHeaderComponent() {
      // Data last updated 5 minutes ago
      this.$store.dispatch("common/setHeaderComponent", {
        title: "Total Smart Solutions",
        subtitle: "",
        showBack: false,
      });
    },
  },
};
</script>

<style lang="scss">
.vel-img {
  background-color: transparent !important;
  box-shadow: none !important;
}
</style>
<style lang="scss" scoped>
.d-contents {
  display: contents;
}

.page-wrapper.only-body .page-body-wrapper .page-body {
  min-height: calc(100vh - 137px);
}

.bg-blue {
  background-color: #0492ff !important;
}

.bg-yellow {
  background-color: #ffae2c !important;
}

.text-green {
  color: #009a78 !important;
}

.text-yellow {
  color: #ffae2c !important;
}

.small-card {
  border-radius: 8px;
  background: #f5f6fa;
  height: calc((100vh - 193px) / 2);
  width: calc((100vw - 130px) / 2);

  .desc {
    padding: 0 25px 0 40px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    color: #9b9a9a;
    font-family: Inter;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    width: 100%;

    button {
      display: flex;
      width: auto;
      height: 38px;
      padding: 10px;
      justify-content: center;
      align-items: center;
      gap: 10px;
      flex-shrink: 0;
      border-radius: 5px;
      border: none;
      background-color: #009a78;
      color: #fff;
      font-family: Inter;
      font-size: 13px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      margin-right: 13px;

      img {
        max-width: 17px;
        max-height: 17px;
      }
    }

    a {
      color: #9b9a9a;
      font-family: Poppins;
      font-size: 15px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
    }

    p {
      margin: 0;
      width: 100%;
    }

    h3 {
      color: #009a78;
      font-family: Inter;
      font-size: 20px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
      margin: 0;
    }
  }

  .image {
    border-radius: 8px 0px 0px 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 185px;
    height: 100%;
    padding: 0;

    img {
      border-radius: 8px 0px 0px 8px;
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: center;
    }
  }
}
</style>
